var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k1wdg1gi1a)",
    fill: "#545454"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.029.985 21.345 8.42l-2.942-1.455L22.186.144a1.24 1.24 0 0 1 1.099 0c.465.233.69.657.744.84zM21.41 9.715c1.733.776 1.562 2.78 1.26 3.686l-8.794-3.88s1.248-2.425 3.266-1.616c.7.28 2.535 1.034 4.268 1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.737 13.304a11.747 11.747 0 0 1-3.18 2.405c-1.486.777-3.11 1.18-4.335 1.392-.128.022-.253.042-.373.06.712.77 1.955 1.823 4.037 2.841 2.128 1.04 3.967 1.557 5.263 1.813.649.128 1.16.191 1.503.222l.03.003c.658-.886 1.348-2.173 1.973-3.528a44.679 44.679 0 0 0 1.614-4.012l1.893.645c-.338.994-.949 2.596-1.691 4.205-.732 1.586-1.633 3.273-2.57 4.367a1 1 0 0 1-.759.35v-1 1h-.059l-.133-.005a10.439 10.439 0 0 1-.477-.033c-.408-.037-.99-.109-1.711-.252-1.444-.285-3.452-.852-5.754-1.978-2.322-1.135-3.774-2.349-4.659-3.314a8.226 8.226 0 0 1-.93-1.208 4.984 4.984 0 0 1-.287-.534l-.007-.014-.002-.006-.001-.003v-.001s-.001-.001.926-.377l-.927.376a1 1 0 0 1 .896-1.376H4.043l.097-.005a16.844 16.844 0 0 0 1.743-.207c1.119-.193 2.517-.55 3.747-1.193a9.752 9.752 0 0 0 2.64-1.992 7.12 7.12 0 0 0 .581-.71 4.128 4.128 0 0 0 .152-.23l.003-.006v.002l-.001.001v.001s-.001.001.871.49l.873.488-.001.002-.002.004-.006.01-.016.026c-.012.022-.03.05-.052.085-.043.07-.106.166-.189.283-.165.233-.41.55-.746.913z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.837 17.538s-1.68 1.455-3.815 1.617l1.81 1.164s1.65-1.423 2.005-2.78zM15.946 18.152c-1.526 1.733-3.977 2.77-5.012 3.072l2.07 1.1s2.554-1.585 2.942-4.172zM7.442 10.57a2.36 2.36 0 1 1-4.72 0 2.36 2.36 0 0 1 4.72 0zM6.602 5.486a.994.994 0 1 1-1.99 0 .994.994 0 0 1 1.99 0zM2.722 5.092a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "k1wdg1gi1a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear_icon.f5a1f27453528ab0af1c56c45797f643.svg";
export { ForwardRef as ReactComponent };